import React from 'react';
import { TranslatedBadge } from './translated_badge';

function NewProductBadge({ color }) {
    return (
        <TranslatedBadge type="new" translationKey="'badge-new'" color={color} />
    );
}

export { NewProductBadge };
